/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate } from 'react-router-dom';

interface HeroProps {
	heroContent: any;
}

export const Hero = ({ heroContent }: HeroProps) => {
	const navigate = useNavigate();

	const handleNavigateToServices = () => {
		if (heroContent?.primaryButtonUrl) {
			navigate(heroContent.primaryButtonUrl);
		}
	};

	return (
		<section className='relative w-full overflow-visible bg-[#242424] min-h-[90vh] flex items-center '>
			{/* Background image */}
			<div className='absolute inset-0 w-full h-full '>
				{heroContent?.backgroundImage?.asset?.url && (
					<img
						src={heroContent.backgroundImage.asset.url}
						alt='Hero background'
						className='w-full h-full object-cover object-center sm:opacity-80 lg:opacity-50 opacity-25'
					/>
				)}
			</div>
			{/* Content container */}
			<div className='relative container mx-auto px-6 md:px-20 py-24 md:py-32 max-w-7xl'>
				<div className='max-w-xl'>
					{/* Hero text content */}
					<h1 className='text-white text-5xl md:text-7xl font-bold mt-4 capitalize'>
						Transforming
						<span className='text-[#FBB040]'> words </span>
						into legacy
						<span className='w-3 h-3 bg-[#FBB040] rounded-full inline-block'></span>
					</h1>

					{/* Hero paragraph */}
					<p className='text-white text-xl mt-8 max-w-lg'>
						{heroContent?.subheading || ''}
					</p>

					{/* CTA Button */}
					<button
						onClick={handleNavigateToServices}
						className='mt-10 bg-white text-neutral-800 font-bold flex items-center gap-2 rounded-full pl-6 pr-2 py-2 cursor-pointer'
					>
						<span>{heroContent?.primaryButtonText || 'Learn More'}</span>
						<div className='bg-[#FBB040] w-8 h-8 rounded-full flex items-center justify-center'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='16'
								height='16'
								viewBox='0 0 24 24'
								fill='none'
								stroke='currentColor'
								strokeWidth='3'
								strokeLinecap='round'
								strokeLinejoin='round'
							>
								<path d='M5 12h14M12 5l7 7-7 7' />
							</svg>
						</div>
					</button>
				</div>
			</div>
		</section>
	);
};
